import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/**
 * AdminGuard — يحمي مسارات المشرف
 * ينتظر استعادة JWT (sessionReady) ثم يتحقق من دور admin عبر AuthContext
 */
export default function AdminGuard({ children }) {
  const {
    user,
    userProfile,
    session,
    sessionReady,
    loading,
    authState,
    AUTH_STATE,
  } = useAuth();

  if (!sessionReady || loading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!session?.access_token || authState === AUTH_STATE.UNAUTHENTICATED || !user?.id) {
    return <Navigate to="/admin-login" replace />;
  }

  if (userProfile?.role !== 'admin') {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
}
